var submitListener = function(e) {
  e.preventDefault();
  grecaptcha.execute();
};

window.noCaptchaFieldRender = () => {
  for(var i=0;i<_noCaptchaFields.length;i++) {
    let fieldId = _noCaptchaFields[i];
    let field = document.getElementById('Nocaptcha-'+fieldId);
    let form = $(field).closest('form').get(0);
    if (!form) {
      noCaptchaApply(fieldId);
      continue;
    }

    let hasEngaged = false;
    let engagementHandler = function() {
      if (hasEngaged) {
        return;
      }

      noCaptchaApply(fieldId);
      hasEngaged = true;
    }

    var inputs = form.querySelectorAll('input, select, textarea, button');
    for (var j = 0, len = inputs.length; j < len; j++) {
      var input = inputs[j];

      if (input && input.addEventListener) {
        input.addEventListener('focus', engagementHandler);
        input.addEventListener('click', engagementHandler);
        input.addEventListener('change', engagementHandler);
        input.addEventListener('input', engagementHandler);
      } else if (input && input.attachEvent) {
        input.attachEvent('focus', engagementHandler);
        input.addEventListener('click', engagementHandler);
        input.addEventListener('change', engagementHandler);
      }
    }
  }
}

function noCaptchaApply(fieldId) {console.log(fieldId);
  var field = document.getElementById('Nocaptcha-'+fieldId);

    var form=$(field).closest('form').get(0);
    var superHandler=false;

    if(typeof jQuery!='undefined' && typeof jQuery.fn.validate!='undefined') {
      var formValidator=jQuery(form).data('validator');
      var superHandler=formValidator.settings.submitHandler;
      formValidator.settings.submitHandler=function(form) {
        grecaptcha.execute();
      };
    }else {
      if(form && form.addEventListener) {
        form.addEventListener('submit', submitListener);
      }else if(form && form.attachEvent) {
        window.attachEvent('onsubmit', submitListener);
      }else if(console.error) {
        console.error('Could not attach event to the form');
      }
    }

    window['Nocaptcha-'+fieldId]=function() {
      if(typeof jQuery!='undefined' && typeof jQuery.fn.validate!='undefined' && superHandler) {
        superHandler(form);
      }else {
        const $action = $(form).find('.action');
        if ($action.length) {
          const $tag = $('<input type="hidden" />').attr('name', $action.attr('name')).attr('value', $action.attr('value'));
          $(form).append($tag);
        }
        form.submit();
      }
    };

  var options={
    'sitekey': field.getAttribute('data-sitekey'),
    'theme': field.getAttribute('data-theme'),
    'type': field.getAttribute('data-type'),
    'size': field.getAttribute('data-size'),
    'badge': field.getAttribute('data-badge'),
    'callback': (field.getAttribute('data-callback') ? field.getAttribute('data-callback') : 'Nocaptcha-'+fieldId)
  };

  var widget_id = grecaptcha.render(field, options);
  field.setAttribute("data-widgetid", widget_id);
}
